import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { UserType } from 'src/app/plasma-ui-common/services/user-role.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class ResultsViewerGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
    private config: ConfigService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const { BasePlasmaUrl } = this.config._envConfig;

    // this will wait for 'auth.profileInfo' to be set in auth.service before loading page
    return this.auth.userInfo$.pipe(
      filter(i => !!i),
      map(claims => {
        const { user_type, two_factor_enabled } = claims;
        const is2faEnabled = two_factor_enabled?.toLowerCase() === 'true';
        const hasResultViewerAccess = user_type?.includes(UserType.ResultsViewer);

        if (hasResultViewerAccess && !is2faEnabled) {
          return this.router.createUrlTree(['/setup-mfa']);
        } else if (hasResultViewerAccess && is2faEnabled) {
          window.location.href = BasePlasmaUrl;
          return true;
        }

        return true;
      }),
    );
  }
}
